// @flow
import { getSafeExpirationDatetime, getSafeDueDate } from '@tectonics/prs/incoming-payment';
import type { PendingIncomingPayment } from '@tectonics/prs/incoming-payment';

export function getExpirationOrDueDatetime(incomingPayment: PendingIncomingPayment): string {
  try {
    const expirationDateTime : string | null = getSafeExpirationDatetime(incomingPayment);
    const dueDate : string = getSafeDueDate(incomingPayment);
    return expirationDateTime ?? getDueDateFullISO8601DateTimeFormat(dueDate) ?? '';
  } catch (e) {
    return '';
  }
}

function getEndOfDayTimeSuffix() : string {
  return  'T23:59:59-03:00';
}

function getDueDateFullISO8601DateTimeFormat(dueDate: string) : string {
  const expectedDateFormat = 'YYYY-MM-DDTHH:mm:SS+HH:mm';
  const expectedLength = expectedDateFormat.length;
  if (dueDate.length === expectedLength) {
    return dueDate;
  }

  const datePart = dueDate.slice(0,10);

  return datePart + getEndOfDayTimeSuffix();
}
